/* eslint-disable @typescript-eslint/prefer-enum-initializers */
// DO NOT MODIFY: Enum is used for comparison of various license types

export enum AccountLicense {
    'UNDEFINED' = -1,
    'ENTERPRISE' = 0,
    'TRIAL' = 1,
    'TEST-TRIAL' = 2,
    'STD-TRIAL' = 3,
    'PRO-TRIAL' = 4,
    'PRO' = 5,
    'COMMUNITY' = 6,
    'FREEKIT' = 7,
    'UNLICENSED' = 8,
}

export enum OrganizationSubscriptionType {
    FREE = 'FREE',
    BUSINESS = 'BUSINESS',
    TRIAL = 'TRIAL',
    FREEKIT = 'FREEKIT',
    PROTRIAL = 'PROTRIAL',
    PRO = 'PRO',
    STDTRIAL = 'STDTRIAL',
    TESTTRIAL = 'TESTTRIAL',
}
